import { api } from '../core';
import { CASE_STATUS_TAG } from '../constants';

export type CaseStartPaginationResponse = null;

export type CaseStartPaginationProps = {
  caseId: string;
};

const caseStartPaginationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCaseStartPagination: builder.query<CaseStartPaginationResponse, CaseStartPaginationProps>({
      query: ({ caseId }: CaseStartPaginationProps) => ({
        url: 'case/start-pagination',
        method: 'POST',
        body: {
          case_id: caseId
        }
      }),
      async onQueryStarted({ caseId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Invalidate case status to trigger immediate refresh
          dispatch(api.util.invalidateTags([{ type: CASE_STATUS_TAG, id: caseId }]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postCaseStartPagination in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostCaseStartPaginationQuery } = caseStartPaginationApi;
